import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const itens = [
    { path: '/',             label: 'Dashboard',    icone: '📊', apenasAdmin: false },
    { path: '/retiradas',    label: 'Retiradas',    icone: '📦', apenasAdmin: false },
    { path: '/agenda',       label: 'Agenda',       icone: '📅', apenasAdmin: false },
    { path: '/bloqueios',    label: 'Bloqueios',    icone: '🔒', apenasAdmin: false  },
    { path: '/funcionarios', label: 'Funcionários', icone: '👥', apenasAdmin: true  },
    { path: '/alterar-senha', label: 'Alterar Senha', icone: '🔑', apenasAdmin: false  },
];

export default function Sidebar() {
    const { user, logout } = useAuth();
    const navigate         = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const estilo = ({ isActive }) => ({
        display:        'flex',
        alignItems:     'center',
        gap:            '10px',
        padding:        '10px 16px',
        borderRadius:   '8px',
        textDecoration: 'none',
        color:          isActive ? '#fff' : '#BDC3C7',
        background:     isActive ? '#2E86C1' : 'transparent',
        fontWeight:     isActive ? '600' : '400',
        transition:     'all 0.15s',
        fontSize:       '14px',
    });

    return (
        <aside style={{
            width:      '220px',
            minHeight:  '100vh',
            background: '#1B2631',
            display:    'flex',
            flexDirection: 'column',
            padding:    '0',
            flexShrink: 0,
        }}>
            <div style={{
                padding:      '24px 16px 20px',
                borderBottom: '1px solid #2C3E50',
            }}>
                <div style={{ color: '#fff', fontWeight: '700', fontSize: '15px' }}>
                    🏛 Coliseum Leilões
                </div>
                <div style={{ color: '#7F8C8D', fontSize: '12px', marginTop: '4px' }}>
                    Painel Administrativo
                </div>
            </div>

            <nav style={{ flex: 1, padding: '12px 10px' }}>
                {itens
                    .filter(item => !item.apenasAdmin || user?.role === 'admin')
                    .map(item => (
                        <NavLink key={item.path} to={item.path} end={item.path === '/'} style={estilo}>
                            <span>{item.icone}</span>
                            <span>{item.label}</span>
                        </NavLink>
                    ))
                }
            </nav>

            <div style={{
                padding:    '16px',
                borderTop:  '1px solid #2C3E50',
            }}>
                <div style={{ color: '#BDC3C7', fontSize: '13px', marginBottom: '4px' }}>
                    {user?.nome}
                </div>
                <div style={{
                    color:        '#7F8C8D',
                    fontSize:     '11px',
                    marginBottom: '12px',
                    textTransform: 'uppercase',
                }}>
                    {user?.role}
                </div>
                <button onClick={handleLogout} style={{
                    width:        '100%',
                    padding:      '8px',
                    background:   '#922B21',
                    color:        '#fff',
                    border:       'none',
                    borderRadius: '6px',
                    cursor:       'pointer',
                    fontSize:     '13px',
                }}>
                    Sair
                </button>
            </div>
        </aside>
    );
}
